import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.ecompradigital.online/cart/45913855623356:1';
const purchases = [{
  name: 'Martín G.',
  city: 'Buenos Aires'
}, {
  name: 'Claudia R.',
  city: 'Córdoba'
}, {
  name: 'Federico L.',
  city: 'Rosario'
}, {
  name: 'Ana Paula M.',
  city: 'Mendoza'
}, {
  name: 'Roberto S.',
  city: 'La Plata'
}, {
  name: 'Silvina D.',
  city: 'Tucumán'
}, {
  name: 'Diego F.',
  city: 'Mar del Plata'
}, {
  name: 'Lorena V.',
  city: 'Salta'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    // Show first popup after 5 seconds
    const initialTimer = setTimeout(() => {
      if (!isDismissed) {
        setIsVisible(true);
      }
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, [isDismissed]);
  useEffect(() => {
    if (!isVisible || isDismissed) return;
    // Hide after 4 seconds, then show next after 2 more seconds
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 4000);
    const showNextTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % purchases.length);
      setIsVisible(true);
    }, 7000);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(showNextTimer);
    };
  }, [isVisible, currentIndex, isDismissed]);
  const handleClick = () => {
    window.open(CHECKOUT_URL, '_blank');
  };
  const handleDismiss = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsDismissed(true);
    setIsVisible(false);
  };
  const current = purchases[currentIndex];
  return <AnimatePresence data-id="element-221">
      {isVisible && !isDismissed && <motion.div initial={{
      opacity: 0,
      y: 100,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 100
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} onClick={handleClick} className="fixed bottom-4 left-4 z-40 bg-white rounded-lg shadow-2xl border border-gray-200 p-4 max-w-xs cursor-pointer hover:shadow-xl transition-shadow" data-id="element-222">
          <button onClick={handleDismiss} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" aria-label="Cerrar" data-id="element-223">
            <XIcon className="w-4 h-4" data-id="element-224" />
          </button>
          <div className="flex items-center gap-3" data-id="element-225">
            <div className="bg-green-100 p-2 rounded-full" data-id="element-226">
              <ShoppingBagIcon className="w-6 h-6 text-green-600" data-id="element-227" />
            </div>
            <div data-id="element-228">
              <p className="text-sm font-semibold text-gray-900" data-id="element-229">
                {current.name} de {current.city}
              </p>
              <p className="text-xs text-gray-600" data-id="element-230">
                acaba de adquirir el Manual Académico
              </p>
              <p className="text-xs text-green-600 font-medium mt-1" data-id="element-231">
                Hace unos momentos
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}